import {
    map,
    isNumber
} from '../../../../common/utils';
import {
    makeDataDays,
    makeGrid,
    makeTooltip
} from './make';

// import { getDataIndex } from './utils';
import {
    formatTipCandle
} from './formatters';

// 序列化数据
function makeDataCandle(klines) {
    return klines ? map(klines, k => [k.open, k.close, k.lowest, k.highest]) : [];
}

// 均线数据
function makeDataMA(klines, dayCount) {
    const maKey = `ma${dayCount}`;
    return klines ? map(klines, k => {
        const ma = k[maKey]
        return isNumber(ma) ? ma : '-'
    }) : [];
}

// 获取蜡烛图配置
function makeSeriesCandle(klines, opts) {
    opts = opts || {}
    const {
        colors
    } = opts
    const {
        up,
        down,
        chartBg
    } = colors
    return {
        name: '日K',
        type: 'candlestick',
        data: makeDataCandle(klines), // TODO: K线数据
        itemStyle: {
            normal: {
                color: chartBg,
                color0: down || '#00da3c',
                borderColor: up || '#f00',
                borderColor0: down || '#0900'
            }
        },
        // markPoint: {
        //     label: {
        //         normal: {
        //             formatter: function (param) {
        //                 return param != null ? Math.round(param.value) : '';
        //             }
        //         }
        //     },
        //     data: [
        //         {
        //           name: 'XX标点',
        //           coord: ['2013/5/31', 2300],
        //           value: 2300,
        //           itemStyle: {
        //             normal: {
        //               color: 'rgb(41,60,85)'
        //             }
        //           }
        //         },
        //         {
        //           name: 'highest value',
        //           type: 'max',
        //           valueDim: 'highest'
        //         },
        //         {
        //           name: 'lowest value',
        //           type: 'min',
        //           valueDim: 'lowest'
        //         // },
        //         // {
        //         //   name: 'average value on close',
        //         //   type: 'average',
        //         //   valueDim: 'close'
        //         }
        //     ],
        //     tooltip: {
        //         formatter: function (param) {
        //             return param.name + '<br>' + (param.data.coord || '');
        //         }
        //     }
        // },
        // markLine: {
        //     symbol: ['none', 'none'],
        //     data: [
        //         // [{
        //         //     name: 'from lowest to highest',
        //         //     type: 'min',
        //         //     valueDim: 'lowest',
        //         //     symbol: 'circle',
        //         //     symbolSize: 10,
        //         //     label: {
        //         //       normal: {
        //         //         show: false
        //         //       },
        //         //       emphasis: {
        //         //         show: false
        //         //       }
        //         //     }
        //         //   },
        //         //   {
        //         //     type: 'max',
        //         //     valueDim: 'highest',
        //         //     symbol: 'circle',
        //         //     symbolSize: 10,
        //         //     label: {
        //         //       normal: {
        //         //         show: false
        //         //       },
        //         //       emphasis: {
        //         //         show: false
        //         //       }
        //         //     }
        //         //   }
        //         // ],
        //         {
        //             name: '最低收盘价',
        //             type: 'min',
        //             valueDim: 'close',
        //             lineStyle: {
        //                 color: down
        //             }
        //         },
        //         {
        //             name: '最高收盘价',
        //             type: 'max',
        //             valueDim: 'close',
        //             lineStyle: {
        //                 color: up
        //             }
        //         }
        //     ]
        // }
    }
}

// 获取均线配置
function makeSeriesMa(klines, {
    days,
    colors
}) {
    colors = colors || {}
    const normal = {
        opacity: 1,
        width: 1,
        color
    }
    const color = colors[`ma${days}`]
    if (color) {
        normal.color = color
    }
    return {
        name: `MA${days}`,
        type: 'line',
        data: makeDataMA(klines, days),
        smooth: true,
        symbolSize: 0, // 不显示节点符号
        lineStyle: {
            normal: normal
        }
    }
}

function makeSeries(klines, {
    colors
}) {
    return [
        makeSeriesCandle(
            klines, {
                colors,
                upColor: colors.up,
                downColor: colors.down,
                upBorderColor: colors.upBorder,
                downBorderColor: colors.downBorder
            }),
        makeSeriesMa(
            klines, {
                days: 5,
                colors
            }),
        makeSeriesMa(
            klines, {
                days: 10,
                colors
            }),
        makeSeriesMa(
            klines, {
                days: 20,
                colors
            })
    ]
}


// 获取蜡烛图选项
export default function makeCandle({
    klines,
    colors
}) {

    if (!klines) {
        return null
    }
    colors = colors || {}
    const curStep = 0
    const beginIndex = 59

    return {
        color: colors.chartColor,
        backgroundColor: colors.chartBg,
        axisPointer: {
            link: {
                xAxisIndex: 'all'
            },
        },
        //color: "#eee",
        animation: false,
        tooltip: makeTooltip(klines, {
            maDays: [5, 10, 20],
            colors
        }, formatTipCandle),
        grid: makeGrid({}),
        xAxis: {
            type: 'category',
            data: makeDataDays(klines), // TODO: 横向数据
            scale: true,
            boundaryGap: false,
            //坐标刻度
            axisTick: {
                show: false
            },
            //坐标标签名
            axisLabel: {
                show: false,
                interval: 0
            },
            axisLine: {
                onZero: false
            },
            splitLine: { //分隔线
                show: true,
                interval: function (index) {
                    return curStep > 0 ? index === curStep : index === beginIndex;
                },
                lineStyle: {
                    color: '#262617',
                    width: 1,
                    type: 'solid'
                }
            },
            splitNumber: 20,
            min: 'dataMin',
            max: 'dataMax'
        },
        yAxis: {
            scale: true,
            splitArea: {
                show: false
            },
            axisLabel: {
                textStyle: {
                    fontSize: 12,
                    color: "#706F77"
                }
            },
            splitLine: {
                lineStyle: {
                    color: "#262617"
                }
            }
        },
        series: makeSeries(klines, {
            colors
        })
    }
}
